import React, { useEffect } from "react";
import { motion, useSpring } from "framer-motion";
import { useAuthStore } from "../../@shared/store/useAuthStore";
import { Box } from "@mui/material";

// Breathing configs
const torsoBreath = {
  animate: {
    scale: [1, 1.02, 1],
    y: [0, -2, 0],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut",
    },
  },
};

const delayedBreath = (delay = 0.1) => ({
  animate: {
    scale: [1, 1.02, 1],
    y: [0, -2, 0],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut",
      delay,
    },
  },
});

const headBreath = {
  animate: {
    y: [0, -2, 0],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut",
    },
  },
};

// Character asset maps
const avatarAssets = {
  zay: {
    segments: {
      legs: require("../../@shared/assets/avatars/zay/zay-idol-legs.png"),
      torso: require("../../@shared/assets/avatars/zay/zay-idol-torso.png"),
      eyes: require("../../@shared/assets/avatars/zay/zay-idol-eyes.png"),
      head: require("../../@shared/assets/avatars/zay/zay-idol-head.png"),
      armLeft: require("../../@shared/assets/avatars/zay/zay-idol-arm-left.png"),
      armRight: require("../../@shared/assets/avatars/zay/zay-idol-arm-right.png"),
    },
  },
  io: {
    segments: {
      torso: "",
    },
  },
};

const AvatarIdolAnimation = ({ name, style = {}, onclick }) => {
  // Infinity Orb animation
  const { userData } = useAuthStore();
  const ySpring = useSpring(0, { stiffness: 60, damping: 15 });

  const isIO =
    name.toLowerCase().includes("io") ||
    name.toLowerCase().includes("infinity") ||
    name.toLowerCase().includes("i.o") ||
    name.toLowerCase().includes("orb");

  useEffect(() => {
    if (isIO) {
      const loop = () => {
        ySpring.set(-5);
        setTimeout(() => ySpring.set(5), 500);
        setTimeout(() => ySpring.set(-5), 1000);
      };
      const interval = setInterval(loop, 1000);
      return () => clearInterval(interval);
    }
  }, [name, ySpring]);

  // Render segmented avatar
  const { segments } = avatarAssets[isIO ? "io" : name];

  const segment = (key, motionProps, zIndex = 2) => (
    <motion.img
      key={key}
      src={segments[key]}
      alt={key}
      style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        zIndex,
        pointerEvents: "none",
        width: "100%",
      }}
      {...motionProps}
    />
  );

  return (
    <motion.div
      onClick={onclick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.25 }}
      style={{
        position: "relative",
        cursor: "pointer",
        width: "50%",
        height: "fit-content",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 50,
        ...style,
      }}
    >
      {isIO ? (
        <motion.img
          style={{
            width: "100%",
            height: "auto",
            y: ySpring,
          }}
          src={userData?.avatar?.image}
          alt=""
        />
      ) : (
        <>
          <img
            src={segments.legs}
            alt=""
            style={{
              //   position: "absolute",
              //   bottom: 0,
              //   left: "20%",
              width: "100%",
              zIndex: 1,
              pointerEvents: "none",
            }}
          />

          {segment("torso", torsoBreath, 2)}

          {segment(
            "eyes",
            {
              animate: { opacity: [0, 1, 0] },
              transition: {
                duration: 0.2,
                repeat: Infinity,
                repeatDelay: 4,
                ease: "easeInOut",
              },
            },
            4
          )}

          {segment("head", headBreath, 3)}
          {segment("armLeft", delayedBreath(0.1), 2)}
          {segment("armRight", delayedBreath(0.1), 2)}
        </>
      )}

      <Box
        sx={{
          position: "absolute",
          bottom: "-1.5%",
          left: "48%",
          transform: "translate(-50%, 0%)",
          width: "50%",
          height: { xs: "30px", md: "40px" },
          borderRadius: "50%",
          backgroundColor: "#00000090",
          filter: "blur(4px)",
        }}
      />
    </motion.div>
  );
};

export default AvatarIdolAnimation;
